<template>
  <div>
    <Breadcrumb :title="'Transfer'"></Breadcrumb>
    <TransferForm
      :ref="'TransferInfoForm'"
      :ProgramUnitClassJsonData="ProgramUnitClassJsonData"
      :TransferInfo="TransferJSON"
      :TransferModalLabel="modalConfig"
    ></TransferForm>
    <div>
      <BaseSearchBar :config="search" @keyupSearch="filterGrid"></BaseSearchBar>
    </div>
    <div class="btnDiv">
      <BaseToolBar :config="ToolbarConfig" @buttonClicked="transferToolBarClick"></BaseToolBar>
    </div>
    <div>
      <BaseGrid
        :mode="'editform'"
        :excelExport="excelExport"
        :config="GridConfig"
        :query="GridConfig.query"
        :colorizeColumn="true"
        @AttachItem="TransferAttachment"
        @EditItem="EditTransfer"
        @DeleteItem="DeleteTransfer"
      ></BaseGrid>
    </div>
    <TransferDocumentDropoffForm
      ref="transferDocument"
      :docModalConfig="docModalConfig"
      :filterCondition="filterCondition"
      :transactionRecord="selectedTransfer"
    ></TransferDocumentDropoffForm>
  </div>
</template>

<script>
// components
import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import BaseGrid from "@/components/base/BaseGrid.vue";
import BaseSearchBar from "@/components/base/BaseSearchBar.vue";
import BaseToolBar from "@/components/base/BaseToolbar.vue";
import BaseModelDocument from "@/models/BaseModelDocument.js";
// services
import apiUtil from "@/services/apiUtil.js";
import funcUtil from "@/services/funcUtil.js";
import toolbarUtility from "@/services/toolbarUtility.js";
// forms
import TransferForm from "@/components/forms/TransferForm.vue";
import TransferDocumentDropoffForm from "@/components/forms/TransferDocumentDropoffForm.vue";
// configs
import {
  GridConfig,
  ToolbarConfig,
  TransferApproveConfig
} from "./TransferEventConfig.js";
import BaseModelUnitClass from "@/models/BaseModelUnitClass.js";
import BaseModelProgram from "@/models/BaseModelProgram.js";
import BaseModelTransactionLog from "@/models/BaseModelTransactionLog.js";
import { mapGetters, mapActions, mapState } from "vuex";
import _ from "lodash";
import { isNullOrUndefined } from "util";
import BusinessEventApprovalMixin from "@/mixins/BusinessEventApprovalMixin.js";

export default {
  name: "TransferEvent",
  mixins: [apiUtil, funcUtil, toolbarUtility,BusinessEventApprovalMixin],
  computed: {
    ...mapGetters("getModule", ["withFilter"]),
    ...mapState("postModule", ["response"])
  },
  components: {
    Breadcrumb,
    BaseGrid,
    BaseSearchBar,
    BaseToolBar,
    TransferForm,
    TransferDocumentDropoffForm
  },
  data: function() {
    return {
      GridConfig: GridConfig,
      search: {
        SearchData: ""
      },
      // Document dropoff modal
      docModalConfig: {
        modalName: "Transfer Documents",
        modalIdandRef: "docModal",
        isFooter: false
      },
      // Filter condition for Document dropoff modal
      filterCondition: {
        filter: "",
        limit: 500
      },
      selectedTransfer: {},
      ToolbarConfig: ToolbarConfig,
      TransferGridId: "TransferGrid",
      BaseModelUnitClass: BaseModelUnitClass,
      modalConfig: {
        modalName: "",
        modalAddorEdit: ""
      },
      TransferJSON: {},
      TransferEditJSON: {
        Id: null,
        BusinessEvent: "",
        ProgramId: null,
        SenderId: null,
        SenderFullName: "",
        ReceiverId: null,
        ProgramTitle: "",
        ReceiverFullName: "",
        UnitClass: "",
        UnitType: "",
        VestingType: "",
        UnitPool: "",
        Unit: "",
        TransactionDate: null,
        Note: "",
        NonAffilateTransfer: false
      },
      TransferMasterData: {},
      ProgramUnitClassJsonData: {
        option: [],
        unitType: [],
        unitPool: []
      }
    };
  },
  methods: {
    ...mapActions("postModule", [
      "DeleteItem",
      "UpdateAllItems",
      "CreateAllItems"
    ]),

    transferToolBarClick: function(e) {
      e.preventDefault();
      switch (e.id) {
        case "btnTransfer":
          this.Transfer();
          window.$("#BaseModal").modal("toggle");
          break;
        case "btnApproveTransfer":
          this.ApproveTransfer();
          break;
        case "btnBulkAttachment":
          this.AttachBatchDocuments();
          break;
        case "btnBulkImportTransfer":
          // this._AlertPopup("Bulk import screen is in progress...");
          this.$router.push("/event/transfer/upload");
          break;
      }
      this._baseToolBarEvents("TransferGrid", ...arguments);
    },
    Transfer: function() {
      this.modalConfig.modalName = "Transfer";
      this.modalConfig.modalAddorEdit = "add";
      this.ProgramUnitClassJsonData.option = [];
      let TransferAddJSON = {
        Id: null,
        BusinessEvent: "",
        ProgramId: null,
        SenderId: null,
        SenderFullName: "",
        ReceiverId: null,
        ReceiverFullName: "",
        ProgramTitle: "",
        UnitClass: "",
        UnitType: "",
        VestingType: "",
        UnitPool: "",
        Unit: 0,
        TransactionDate: null,
        Status: "",
        Note: ""
      };
      this.$refs.TransferInfoForm.AvailableUnits = 0;
      this.TransferJSON = TransferAddJSON;
    },
    EditTransfer: function(e) {
      let self = this;
      e.preventDefault();
      this.modalConfig.modalName = "Edit Transfer";
      this.modalConfig.modalAddorEdit = "edit";
      //alert("Edit button clicked from BaseGrid..");
      let gview = window.$("#TransferGrid").data("kendoGrid");
      // var dataItem1 = gview.dataItem(window.$(e.currentTarget).closest("tr"));
      let dataItem = JSON.parse(
        JSON.stringify(gview.dataItem(window.$(e.currentTarget).closest("tr")))
      );
      //  alert(JSON.stringify(dataItem));
      //dataItem.TreasuryUnits = 500; // Hardcoded value for demo

      this.TransferEditJSON = dataItem;

      let unitClassQuery = { filter: "ProgramId eq " + dataItem.ProgramId };
      this.ProgramUnitClassJsonData.option = this.withFilter(
        BaseModelUnitClass.list,
        unitClassQuery
      );

      this.TransferJSON = this.TransferEditJSON;

      //this.$refs.TransferInfoForm.AvailableUnits = 0;
      this.$refs.TransferInfoForm.calculateAvailableUnits(this.TransferJSON);
      window.$("#BaseModal").modal("toggle");
    },
    DeleteTransfer: function(e) {
      e.preventDefault();
      //alert("Delete button clicked from BaseGrid..");
      const message = "Are you sure you want to delete this record?";
      this._ConfirmationPopup(message, "DELETE").then(result => {
        if (result.value) {
          let gview = window.$("#TransferGrid").data("kendoGrid");
          let dataItem = gview.dataItem(
            window.$(e.currentTarget).closest("tr")
          );
          let deleteTranfer = {
            Id: dataItem.Id
          };
          //let loader = this.$loading.show();
          this._APICrudPopup("APICrudpopup");
          let items = { list: GridConfig, payload: deleteTranfer };
          this.DeleteItem(items).then(response => {
            $("#TransferGrid")
              .data()
              .kendoGrid.dataSource.read();
            this._AlertPopup("Deleted successfully!", "success");
          }).catch(error=>{
            this._AlertPopup("Some Error Occurred!","info");
          }).finally(()=>{
            //loader.hide();
          })
        }
      });
    },
    async ApproveTransfer() {
      let grid = $("#TransferGrid").data("kendoGrid");
      let selectedItem = [];
      let TransactionData = [];
      grid.select().each(function() {
        let selectedDataItem = JSON.parse(JSON.stringify(grid.dataItem(this)));
        if (selectedDataItem.WorkflowStatus == "Pending") {
          selectedDataItem.Status = "Processing";
          //push the dataItem into the array
          selectedItem.push(selectedDataItem);
        }
      });
      if (selectedItem.length > process.env.VUE_APP_ApprovalLimitCount) {
        this._AlertPopup(`You can only Approve ${process.env.VUE_APP_ApprovalLimitCount} records at a time`, "info");
        return;
      }
      console.log("Selected Transfer", selectedItem);
      selectedItem.forEach(Transfer => {
        let TransactionSender = {};
        TransactionSender.BusinessEvent = Transfer.BusinessEvent;
        TransactionSender.ProgramId = Transfer.ProgramId;
        TransactionSender.UnitClass = Transfer.UnitClass;
        TransactionSender.UnitType = Transfer.UnitType;
        TransactionSender.UnitPool = Transfer.UnitPool;
        TransactionSender.Unit = -(Transfer.Unit);
        TransactionSender.VestingType = Transfer.VestingType;
        TransactionSender.TransactionDate = Transfer.TransactionDate;
        TransactionSender.PartnerId = Transfer.SenderId;
        TransactionSender.TransactionId = Transfer.Id;
        TransactionData.push(TransactionSender);

        let TransactionReceiver = _.clone(TransactionSender);
        TransactionReceiver.PartnerId = Transfer.ReceiverId;
        TransactionReceiver.Unit=-1*TransactionReceiver.Unit;

        TransactionData.push(TransactionReceiver);
      });
      console.log("Transaction Data", TransactionData);
      // TransactionData
      if (selectedItem.length <= 0) {
        this._AlertPopup("Please select atleast one pending item.", "info");
      } else {
        const message =
          "Are you sure you want to approve the selected record(s)?";
        let result = await this._ConfirmationPopup(message, "APPROVE")
          if (result.value) {           
            //let loader = this.$loading.show();
             this._APICrudPopup("APICrudpopup");
            //need to update the DB
            console.log(selectedItem);
            //using Update All method

            const approveConfig = {
              Transfer: {
                config: GridConfig,
                updateData: selectedItem,
                processInBatches:true
              }
            };
            let transactionCreateConfig = {
                    TransactionLog: {
                      config: BaseModelTransactionLog,
                      createData: TransactionData,
                      processInBatches:true
                    }
                  };
            try{
              let transactionCreateResponse =null;

              let approveResponse=await this.UpdateAllItems(approveConfig);

              if (approveResponse) {
                transactionCreateResponse=await this.CreateAllItems(transactionCreateConfig);
              }
              if (transactionCreateResponse && process.env.VUE_APP_BusinessEventApproval=="true") {
                let runningTotalResponse= await this._RunningTotalEvent(TransactionData,true,true,false)
                console.log("runningTotalResponse",runningTotalResponse)
              }
              $("#TransferGrid").data().kendoGrid.dataSource.read();
              this._AlertPopup("Submitted for Processing Successfully!","success");
            }
            catch(error){
              this._AlertPopup("Some Error Occurred!","info");
            }
          }
      }
    },
    UpdateTransferMasterData: function(fromFilter, filterMasterData) {
      if (fromFilter == true) {
        this.TransferMasterData = filterMasterData;
      } else {
        this.TransferMasterData = $("#TransferGrid")
          .data()
          .kendoGrid.dataSource.data();
      }
      //Disable Rows which are not pending
      this._disableGridRow("TransferGrid","WorkflowStatus","neq","pending")
    },
    filterGrid: function() {
      let self = this;

      let currentMasterdata = this.TransferMasterData;

      let filteredData = this._filterGrid(
        this.TransferMasterData,
        this.search.SearchData
      );

      $("#TransferGrid")
        .data("kendoGrid")
        .dataSource.data(filteredData);
      this.UpdateTransferMasterData(true, currentMasterdata);
    },
    // Transfer Documnet Dropoff
    TransferAttachment: function(e) {
      let self = this;
      e.preventDefault();
      const gview = window.$("#TransferGrid").data("kendoGrid");
      const dataItem = gview.dataItem(window.$(e.currentTarget).closest("tr"));

      this.selectedTransfer = { ...dataItem };
      //TEMP: Only for Transfer Page.. Building Partner Record for the Time Being
      (this.selectedTransfer.PartnerTitle = dataItem.ReceiverFullName),
        (this.selectedTransfer.PartnerId = dataItem.ReceiverId);
      this.selectedTransfer.TransactionID = dataItem.Id;

      //this.filterCondition.filter = `BusinessEvent eq 'Transfer' and TransactionID eq ${dataItem.Id}`;

      this.filterCondition.batchQuery = true;

      let BatchGUIDArray = self.GetBatchGUIDArray(
        this.selectedTransfer.BatchGUID
      );

      this.filterCondition.filter = function(o) {
        return (
          o.BusinessEvent == "Transfer" &&
          (o.TransactionID == dataItem.Id ||
            BatchGUIDArray.includes(o.BatchGUID))
        );
      };

      this.$refs.transferDocument.$refs.transferDocumentMgr.resetDropZoneGrid();

      window.$("#docModal").modal("toggle");
    },
    AttachBatchDocuments() {
      let selectedItem = [];
      let selectedRowCount = 0;

      //Get Next Batch Id
      const result = this.withFilter(BaseModelDocument.list, "");
      let batchId =
        result.length <= 0 ? 1 : this._getIncrementalID(result, "BatchGUID");

      //Partner Program Concatenated List Change
      let programIdlist = new Set();
      let partnerIdList = new Set();

      let grid = $("#TransferGrid").data("kendoGrid");
      grid.select().each(function() {
        selectedRowCount++;
        let selectedDataItem = JSON.parse(JSON.stringify(grid.dataItem(this)));
        let tempBatchId = [];
        if (
          !isNullOrUndefined(selectedDataItem.BatchGUID) &&
          !selectedDataItem.BatchGUID == ""
        ) {
          tempBatchId = selectedDataItem.BatchGUID.split(",");
        }
        tempBatchId.push(batchId);
        selectedDataItem.BatchGUID = tempBatchId.toString();

        selectedItem.push(selectedDataItem);
        programIdlist.add(selectedDataItem.ProgramId);
        partnerIdList.add(selectedDataItem.ReceiverId);
        partnerIdList.add(selectedDataItem.SenderId);
      });

      if (selectedRowCount <= 1) {
        this._AlertPopup("Please Select Atleast 2 Rows", "info");
      } else {
        const batchConfig = {
          Transfer: {
            config: GridConfig,
            updateData: selectedItem
          }
        };

        this.selectedTransfer = {};
        this.selectedTransfer.ProgramId = null;
        this.selectedTransfer.PartnerId = null;
        this.selectedTransfer.ProgramIdList = [...programIdlist].toString();
        this.selectedTransfer.PartnerIdList = [...partnerIdList].toString();
        this.selectedTransfer.TransactionID = null;
        this.selectedTransfer.BusinessEvent = "Transfer";
        this.selectedTransfer.Type = "batch";
        this.selectedTransfer.BatchGUID = batchId;
        this.selectedTransfer.batchConfig = batchConfig;
        this.selectedTransfer.parentGridId = "TransferGrid";

        this.filterCondition.batchQuery = false;

        this.filterCondition.filter = `BusinessEvent eq 'Transfer' and BatchGUID eq ${batchId}`;

        this.$refs.transferDocument.$refs.transferDocumentMgr.resetDropZoneGrid();

        window.$("#docModal").modal("toggle");
      }
    }
  },
  mounted() {
    //bind databound event to grid
    let grid = $("#TransferGrid").data("kendoGrid");
    grid.bind("dataBound", this.UpdateTransferMasterData);
    grid.dataSource.fetch();

    this._loadGridSettings("TransferGrid");
  }
};
</script>

